import { AxiosError, AxiosInstance } from 'axios'

import { createAuthedHttpClient } from '@driftt/web-auth'

import config from 'config'
import { captureExceptionWithMessage } from 'utils/logRocket'

const logErrorHandler = (error: AxiosError) => {
  captureExceptionWithMessage('Unified Contacts API Error', error, {
    url: window.location.href,
    endpoint: error.config.url,
    errorData: JSON.stringify(error.config)
  })
}

const responseErrorHandlers = [logErrorHandler]

export const UnifiedContactsApi: AxiosInstance = createAuthedHttpClient({
  responseErrorHandlers,
  baseConfig: {
    baseURL: config.UNIFIED_CONTACTS_API
  }
})
export const getUnifiedContact = (endUserId: string) => {
  return UnifiedContactsApi.get(`/${endUserId}`).then(res => res.data)
}
